import React from 'react'
import LogoutButton from './login/LogoutButton'

interface HeaderProps {
  loginStatus: boolean
  setLoginStatus: React.Dispatch<React.SetStateAction<boolean>>
}

function Header({ loginStatus, setLoginStatus }: HeaderProps): React.ReactElement | null {
  return loginStatus ? (
    <header className="header">
      <div className="headerTitles">
        <h1>Rekovar&apos;s Annotation Tool</h1>
      </div>
      <LogoutButton setLoginStatus={setLoginStatus} />
    </header>
  ) : null
}

export default Header
